import React from 'react';
import Link from 'next/link';
import styled from 'styled-components';

type TProps = {
  communityUrl: string;
  boardId?: string;
  width: number;
};

const CommunityWriteButton: React.FC<TProps> = ({ communityUrl, boardId, width }) => {
  return (
    <StyledLink width={width}>
      <Link href={`${communityUrl}/new-post?board_id=${boardId}`} prefetch={false} target={'_blank'}>
        <span className="button-text">게시글 작성</span>
      </Link>
    </StyledLink>
  );
};

export default CommunityWriteButton;

const StyledLink = styled.div<{ width: number }>`
  a {
    display: inline-block;
    width: ${({ width }) => width}px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    background-color: #01a0ff;
    color: #fff;
    border-radius: 8px;
    cursor: pointer;
  }

  .button-text::after {
    content: '하기';
  }

  @media ${({ theme }) => theme.device.mobile} {
    a {
      width: 100%;
      padding: 0 25px;
      height: 40px;
      line-height: 40px;
      font-size: 13px;
    }

    .button-text::after {
      content: '';
    }
  }
`;
